module.exports = __webpack_public_path__ + "img/32.7ad57a02.jpg";